export default "__VITE_ASSET__CdLJLfiU__"